import gql from 'graphql-tag';

export const mutationSendShareEmail = gql`
  mutation sendShareEmail (
    $description: String!
    $email: String!
    $message: String
    $url: String!
  ) {
    sendShareEmail (
      description: $description
      email: $email
      message: $message
      url: $url
    )
  }
`;
export default mutationSendShareEmail;
